import getNotificationRead from './getNotificationRead'
import makeNewRequest from './makeNewRequest'

export const getNotificationReadPromise = getNotificationRead
export const makeNewRequestPromise = makeNewRequest
